import React, { useState, useEffect } from "react";
import useLangTranslation from "../../../customHooks/languageProvider";
import useSubscription from "../../../customHooks/subscriptionProvider";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import {
  timeSupervision,
  // setRulesDataApi,
  setRulesData as setRulesDataMethod,
} from "../../AxiosRtk/DashBoard";
import { AlertModal } from "../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../setup/alert/iconTypes";
import { setShowMessage, setErrorInfo } from "../../AxiosRtk/successMessage";
import useDurationOption from "../../../customHooks/durationOption";
import Select from "react-select";

const initialValueForDayTime = {
  monday: 0,
  tuesday: 0,
  wednesday: 0,
  thursday: 0,
  friday: 0,
  saturday: 0,
  sunday: 0
};

const initialValueForDayToggleData = {
  monday: 0,
  tuesday: 0,
  wednesday: 0,
  thursday: 0,
  friday: 0,
  saturday: 0,
  sunday: 0,
};

const SetDailyLimitBody = ({
  deviceId,
  postCollectionData,
  getCollectionData,
  createCollectionData,
  setRulesData,
}) => {
  // console.log(deviceId)
  const { checkSubsciption } = useSubscription();
  const dispatch = useDispatch();
  const [time, setTime] = useState({
    hours: { value: 0, error: "" },
    minutes: { value: 0, error: "" },
  });
  const { daysAndWeekFunction } = useDurationOption();
  const daysAndWeekOptions = daysAndWeekFunction();
  const [error, setError] = useState("");
  const [apiHit, setApiHit] = useState(false);
  // const [totalMin, setTotalMin] = useState(0);
  const [daySelect, setDaySelect] = useState("");
  const [dayTime, setDayTime] = useState(initialValueForDayTime);
  const [dayToggleData, setDayToggleData] = useState(
    initialValueForDayToggleData
  );
  // console.log("dayTime ==>>", dayTime)
  const { getLangTranslation } = useLangTranslation();
  // console.log(time)
  const { selectedKidId } = useSelector(({ dashboard }) => dashboard);

  // const { setRulesData } = useSelector(({ setRules }) => setRules);

  useEffect(() => {
    if (setRulesData?.timesupervison) {
      // console.log(setRulesData)
      const { dailyLimit, dailyLimitSelectedDays } =
        setRulesData?.timesupervison;

      const dailyTimeLimit = dailyLimit;
      const dailyTimeToggleData = dailyLimitSelectedDays;

      // console.log(dailyTimeLimit, dailyTimeToggleData)

      if (!isEmpty(dailyTimeLimit)) {
        // console.log("hi")
        setDayTime(dailyTimeLimit);
      }

      if (!isEmpty(dailyTimeToggleData)) {
        // console.log("bye")
        setDayToggleData(dailyTimeToggleData);
      }
    } else {
      setDaySelect("");
      setDayTime({
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
        sunday: 0,
      });
      setDayToggleData({
        monday: 0,
        tuesday: 0,
        wednesday: 0,
        thursday: 0,
        friday: 0,
        saturday: 0,
        sunday: 0,
      });
    }
  }, [setRulesData]);

  function handleInputChange(e) {
    const { name, value } = e.target;
    // console.log("value ==>>", value);
    // console.log((parseInt(value) * 60 + parseInt(time?.minutes?.value)))
    if (
      name === "hours" &&
      parseInt(value) * 60 + parseInt(time?.minutes?.value) > 1439
    ) {
      setError("YOU_CANNOT_ADD_TIME_LIMT_MORE_THAN_24_HR_TXT");
      return;
    } else if (
      name === "minutes" &&
      parseInt(time?.hours?.value) * 60 + parseInt(time?.minutes?.value) > 1439
    ) {
      setError("YOU_CANNOT_ADD_TIME_LIMT_MORE_THAN_24_HR_TXT");
      return;
    }

    // if (name === 'minutes' && time?.hours?.value == 24) {
    //     return;
    // }

    if (name === "hours") {
      if (value < 0 || value > 24) {
        return;
      }
      setTime({
        ...time,
        hours: {
          value,
          error: "",
        },
      });
      setError("");
    } else if (name === "minutes") {
      if (value < 0 || value > 59) {
        return;
      }
      setTime({
        ...time,
        minutes: {
          value,
          error: "",
        },
      });
      setError("");
    } else if (name === "day-select") {
      setDaySelect(value);
    }
  }

  function handleClearAllBtn() {
    setDayTime({
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
    });
    setDayToggleData({
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
    });
    setTime({
      hours: { value: 0, error: "" },
      minutes: { value: 0, error: "" },
    });
    setError("");
    setDaySelect("");
  }

  function minConvertToHr(minutes) {
    if (minutes === 0) return `00 h 00 m`;
    else {
      const minInt = parseInt(minutes);
      const hr =
        Math.floor(minInt / 60) < 10
          ? `0${Math.floor(minInt / 60)}`
          : `${Math.floor(minInt / 60)}`;
      const min =
        Math.floor(minInt % 60) < 10
          ? `0${Math.floor(minInt % 60)}`
          : `${Math.floor(minInt % 60)}`;

      return `${hr} h ${min} m`;
    }
  }

  function handleToggleCheck(e) {
    if (!deviceId) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Plese select device",
          defaultTitle: "Please select device",
        })
      );
      // AlertModal("Please select device", alertIconType?.errorIcon, true);
      return;
    }
    const { name, checked } = e.target;
    const tempToggleData = { ...dayToggleData };
    tempToggleData[name] = checked ? 1 : 0;

    setDayToggleData(tempToggleData);
    timeSupervisionApi(tempToggleData);
  }

  function timeSupervisionApi(toggleData = null) {
    // let dailyLimit = {
    //   monday: dayTime?.monday,
    //   tuesday: dayTime?.tuesday,
    //   wednesday: dayTime?.wednesday,
    //   thursday: dayTime?.thursday,
    //   friday: dayTime?.friday,
    //   saturday: dayTime?.saturday,
    //   sunday: dayTime?.sunday,
    // };

    // const dailyToggleData = { ...dayToggleData };

    let dailyLimit = { ...dayTime };

    const dailyToggleData = { ...dayToggleData };

    const totalMin =
      parseInt(time?.hours?.value * 60) + parseInt(time?.minutes?.value);

    // console.log(totalMin, daySelect)

    if (daySelect === "WEEKDAYS") {
      dailyLimit["monday"] = totalMin;
      dailyLimit["tuesday"] = totalMin;
      dailyLimit["wednesday"] = totalMin;
      dailyLimit["thursday"] = totalMin;
      dailyLimit["friday"] = totalMin;
      dailyToggleData["monday"] = 1;
      dailyToggleData["tuesday"] = 1;
      dailyToggleData["wednesday"] = 1;
      dailyToggleData["thursday"] = 1;
      dailyToggleData["friday"] = 1;
    } else if (daySelect === "WEEKEND") {
      dailyLimit["saturday"] = totalMin;
      dailyLimit["sunday"] = totalMin;
      dailyToggleData["saturday"] = 1;
      dailyToggleData["sunday"] = 1;
    } else if (daySelect === "MONDAY") {
      dailyLimit["monday"] = totalMin;
      dailyToggleData["monday"] = 1;
    } else if (daySelect === "TUESDAY") {
      dailyLimit["tuesday"] = totalMin;
      dailyToggleData["tuesday"] = 1;
    } else if (daySelect === "WEDNESDAY") {
      dailyLimit["wednesday"] = totalMin;
      dailyToggleData["wednesday"] = 1;
    } else if (daySelect === "THURSDAY") {
      dailyLimit["thursday"] = totalMin;
      dailyToggleData["thursday"] = 1;
    } else if (daySelect === "FRIDAY") {
      dailyLimit["friday"] = totalMin;
      dailyToggleData["friday"] = 1;
    } else if (daySelect === "SATURDAY") {
      dailyLimit["saturday"] = totalMin;
      dailyToggleData["saturday"] = 1;
    } else if (daySelect === "SUNDAY") {
      dailyLimit["sunday"] = totalMin;
      dailyToggleData["sunday"] = 1;
    } else if (daySelect === "EVERYDAY") {
      dailyLimit["monday"] = totalMin;
      dailyLimit["tuesday"] = totalMin;
      dailyLimit["wednesday"] = totalMin;
      dailyLimit["thursday"] = totalMin;
      dailyLimit["friday"] = totalMin;
      dailyLimit["saturday"] = totalMin;
      dailyLimit["sunday"] = totalMin;
      dailyToggleData["monday"] = 1;
      dailyToggleData["tuesday"] = 1;
      dailyToggleData["wednesday"] = 1;
      dailyToggleData["thursday"] = 1;
      dailyToggleData["friday"] = 1;
      dailyToggleData["saturday"] = 1;
      dailyToggleData["sunday"] = 1;
    }

    // console.log(dailyLimit, dailyToggleData)
    const dailyLimitDayFormattedDB = {};

    for (let day in dailyLimit) {
      dailyLimitDayFormattedDB[`${day[0]?.toUpperCase()}${day.slice(1)}`] =
        dailyLimit[day];
    }

    let tempDailyLimitSelectedDays = {};
    if (isEmpty(toggleData)) {
      for (let day in dailyToggleData) {
        tempDailyLimitSelectedDays[`${day[0]?.toUpperCase()}${day.slice(1)}`] =
          dailyToggleData[day];
      }
      // tempDailyLimitSelectedDays = { ...dailyToggleData }
    } else {
      for (let day in toggleData) {
        tempDailyLimitSelectedDays[`${day[0]?.toUpperCase()}${day.slice(1)}`] =
          toggleData[day];
      }
    }

    const payload = {
      kidId: selectedKidId,
      deviceId,
      DailyLimit: dailyLimitDayFormattedDB,
      dailyLimitSelectedDays: tempDailyLimitSelectedDays,
      IsWarnKidByAlertEnabled:
        setRulesData?.timesupervison?.isWarnKidByAlertEnabled,
      IsDeviceTimeSupervisionEnabled:
        setRulesData?.timesupervison?.isDeviceTimeSupervisionEnabled,
      IsBlockWebAndAppEnabled:
        setRulesData?.timesupervison?.isBlockWebAndAppEnabled,
      IsAllowAndMonitorParentsEnabled:
        setRulesData?.timesupervison?.isAllowAndMonitorParentsEnabled,
      dailyLimitSeekBarProgress: totalMin,
      AllowedApps: [],
      AllowedContacts: [],
    };

    // console.log("set rules data ==>>", setRulesData)
    let toggleDataCollectionPayload = {};
    if (!isEmpty(toggleData)) {
      // for (const key in toggleData) {
      //   toggleDataCollectionPayload[`${key[0]?.toUpperCase()}${key?.slice(1)}`] = dailyToggleData[key]
      // }
      toggleDataCollectionPayload = { ...toggleData };
    } else {
      for (const key in dailyToggleData) {
        toggleDataCollectionPayload[
          `${key[0]?.toLowerCase()}${key?.slice(1)}`
        ] = dailyToggleData[key];
      }
    }

    const collectionPayload = {
      ...setRulesData?.timesupervison,
      dailyLimit,
      dailyLimitSelectedDays: toggleDataCollectionPayload,
      dailyLimitSeekBarProgress: totalMin,
    };
    // console.log("collectionPayload ==>>", collectionPayload)

    // console.log("payload ==>>", payload)

    if (setRulesData) {
      postCollectionData(deviceId, { timesupervison: collectionPayload });
    } else {
      createCollectionData(deviceId, { timesupervison: collectionPayload });
    }

    // console.log(payload)

    getCollectionData(deviceId);
    setApiHit(true);

    timeSupervision(payload)
      .then((response) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: response?.data?.message,
            message: response?.data?.message,
          })
        );
      })
      .catch((err) => {
        console.log(
          "time supervision catch error ==>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setApiHit(false);
      });
  }

  function handleAddLimitBtn() {
    // console.log(deviceId)
    if (!checkSubsciption()) {
      return;
    }
    if (!deviceId) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Device not selected",
          defaultTitle: "Device not selected",
        })
      );
      return;
    } else if (isEmpty(daySelect)) {
      dispatch(
        setErrorInfo({
          errorInfo: true,
          title: "Day not selected",
          defaultTitle: "Day not selected",
        })
      );
      return;
    }

    timeSupervisionApi();
  }
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const handleIncrementHours = () => {
    if (time?.hours?.value < 23) {
      setTime({
        ...time,
        hours: { value: parseInt(time?.hours?.value) + 1, error: "" }
      })
    }
  };

  const handleDecrementHours = () => {
    if (time?.hours?.value > 0) {
      setTime({
        ...time,
        hours: { value: parseInt(time?.hours?.value) - 1, error: "" }
      })
    }
  };

  const handleIncrementMinutes = () => {
    if (time?.minutes?.value < 59) {
      setTime({
        ...time,
        minutes: { value: parseInt(time?.minutes?.value) + 1, error: "" }
      })
    }
  };

  const handleDecrementMinutes = () => {
    if (time?.minutes?.value > 0) {
      // onChangeMinutes(minutes - 1);
      setTime({
        ...time,
        minutes: { value: parseInt(time?.minutes?.value) - 1, error: "" }
      })
    }
  };

  return (
    <div className="card mb-6">
      <div className="card-body">
        <div
          className="alert alert-danger alert-dismissible fade show d-flex align-items-center gap-3 mb-6"
          role="alert"
        >
          Please note that if the schedule is enabled, the priority will go to
          the schedule, please disable the schedule if you want to use a daily
          limit.
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="alert"
            aria-label="Close"
          ></button>
        </div>
        <div className="d-flex align-items-center gap-6 justify-content-between mb-6 flex-wrap">
          <h5 className="mb-0 text-blue-900">
            {getLangTranslation(
              "HOW_TO_SET_RULES_TIME_SUPERVISION_SET_DAILY_LIMIT",
              "Set daily limit"
            )}
          </h5>
          <div className="d-flex align-items-center gap-6 flex-wrap flex-md-nowrap">
            <Select
              className="custom-select col-md-3"
              classNamePrefix="custom-select"
              placeholder="Select"
              onChange={(val) => {
                setDaySelect(val.value);
              }}
              options={daysAndWeekOptions}
              value={
                daysAndWeekOptions?.find((item) => item?.value == daySelect) ||
                ""
              }
            />
            <div className="d-flex align-items-center gap-3 w-100">
              <span className="text-small text-uppercase text-gray text-nowrap">
                {getLangTranslation("LOCK_DEVICE_CHOOSE_TIME", "Choose Time")}
              </span>
              <>
                <div className="d-flex gap-3">
                  <div className="form-control-num content-110">
                    <div className="position-relative">
                      <input
                        type="number"
                        className="form-control text-blue-900 fw-semibold"
                        placeholder="hh"
                        name="hours"
                        value={time?.hours?.value}
                        onChange={(e) => handleInputChange(e)}
                      />
                      <span
                        className="position-absolute top-50 text-blue-900 translate-middle-y"
                        style={{ left: "30px" }}
                      >
                        h
                      </span>
                    </div>

                    <div className="form-control-num-arrows blue-900">
                      <i
                        className="icon-arrow-left arrow-up"
                        onClick={() => handleIncrementHours()}
                      />
                      <i
                        className="icon-arrow-left arrow-down"
                        onClick={() => handleDecrementHours()}
                      />
                    </div>
                  </div>
                  <div className="form-control-num">
                    <div className="position-relative">
                      <input
                        type="number"
                        className="form-control text-blue-900 g-col-2 fw-semibold"
                        name="minutes"
                        placeholder="mm"
                        value={time?.minutes?.value}
                        onChange={(e) => handleInputChange(e)}
                      />
                      <span
                        className="position-absolute top-50 text-blue-900 translate-middle-y"
                        style={{ left: "30px" }}
                      >
                        m
                      </span>
                    </div>
                    <div className="form-control-num-arrows blue-900">
                      <i
                        className="icon-arrow-left arrow-up"
                        onClick={handleIncrementMinutes}
                      />
                      <i
                        className="icon-arrow-left arrow-down"
                        onClick={handleDecrementMinutes}
                      />
                    </div>
                  </div>
                </div>
                {error && (
                  <div>
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {getLangTranslation(error)}
                    </span>
                  </div>
                )}
              </>
            </div>
            <div className="d-flex align-items-center gap-3">
              <button
                className="btn btn-primary g-col-6"
                type="button"
                onClick={handleAddLimitBtn}
                disabled={apiHit}
              >
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation("ADD_LIMIT", "Add Limit")}
                </span>
              </button>
              <button
                className="btn btn-outline-primary g-col-6"
                type="button"
                onClick={handleClearAllBtn}
              >
                <span className="btn-upper-case text-nowrap">
                  {getLangTranslation(
                    "PARENT_NOTIFICATION_FILTER_CLEAR_ALL",
                    "CLEAR ALL"
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
        <ul className={`bordered-list ${lang?.isRTL === 1 ? "pe-0" : ""}`}>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_MONDAY",
                  "Monday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  name="monday"
                  checked={!!dayToggleData?.monday}
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.monday)}
            </span>
          </li>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_TUESDAY",
                  "Tuesday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  name="tuesday"
                  checked={!!dayToggleData?.tuesday}
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.tuesday)}
            </span>
          </li>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_WEDNESDAY",
                  "Wednesday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={!!dayToggleData?.wednesday}
                  name="wednesday"
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.wednesday)}
            </span>
          </li>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_THURSDAY",
                  "Thursday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={!!dayToggleData?.thursday}
                  name="thursday"
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.thursday)}
            </span>
          </li>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_FRIDAY",
                  "Friday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={!!dayToggleData?.friday}
                  name="friday"
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.friday)}
            </span>
          </li>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_SATURDAY",
                  "Saturday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={!!dayToggleData?.saturday}
                  name="saturday"
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.saturday)}
            </span>
          </li>
          <li className="text-center">
            <label className="pt-cursor">
              <span className="text-blue-800 text-small text-uppercase">
                {getLangTranslation(
                  "TIME_SUPERVISION_SET_SCHEDULE_SUNDAY",
                  "Sunday"
                )}
              </span>
              <span className="form-check form-switch mx-auto mt-2">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={!!dayToggleData?.sunday}
                  name="sunday"
                  onChange={handleToggleCheck}
                />
              </span>
            </label>
            <span className="bordered-list-text">
              {minConvertToHr(dayTime?.sunday)}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SetDailyLimitBody;
